export default __webpack_public_path__ + "static/media/logo1.e48c3f5a.png";